import { createAsyncThunk } from '@reduxjs/toolkit';
import { courseApi } from '~/apis/course';
import {
  GET_COURSES_OF_STUDENT,
  GET_DETAIL_COURSES,
  GET_LIST_COURSES,
  GET_MODULE_OF_COURSE,
} from '~/utils/constants/actionType';
import { IPayloadGetModulesOfCourse, IQueryGetCoursesOfStudent } from '~/utils/interface/course';

export const getListCourses = createAsyncThunk(GET_LIST_COURSES, async (_, { rejectWithValue }) => {
  try {
    const res = await courseApi.getListCourses();
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getDetailCourse = createAsyncThunk(
  GET_DETAIL_COURSES,
  async (payload: { coursesId: string; lessonId: string }, { rejectWithValue }) => {
    try {
      const res = await courseApi.getDetailCourse(payload.coursesId, payload.lessonId);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCoursesOfStudent = createAsyncThunk(
  GET_COURSES_OF_STUDENT,
  async (payload: IQueryGetCoursesOfStudent, { rejectWithValue }) => {
    try {
      const res = await courseApi.getCoursesOfStudent(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getModulesOfCourse = createAsyncThunk(
  GET_MODULE_OF_COURSE,
  async (payload: IPayloadGetModulesOfCourse, { rejectWithValue }) => {
    try {
      const res = await courseApi.getModulesOfCourse(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
